import { render, staticRenderFns } from "./CustomPrintExtractor.vue?vue&type=template&id=056f3782&scoped=true&"
import script from "./CustomPrintExtractor.vue?vue&type=script&lang=js&"
export * from "./CustomPrintExtractor.vue?vue&type=script&lang=js&"
import style0 from "./CustomPrintExtractor.vue?vue&type=style&index=0&id=056f3782&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f3782",
  null
  
)

export default component.exports